import { useTrialBanner } from "@/react/components/Layout/TrialBanner/useTrialBanner";
import { TrialBanner } from "./TrialBanner";

export const TrialOffer = () => {
  const { isCommunityOnTrial } = useTrialBanner();

  if (!isCommunityOnTrial) {
    return null;
  }

  return <TrialBanner />;
};
